import {
  CANDIDATE_CITY_LIST_LOADER,
  CANDIDATE_LIST_ACTIVE_PROJECTS_FILTER,
  CANDIDATE_LIST_AVAILABLE_HOURS_FILTER,
  CANDIDATE_LIST_CITY_FILTER,
  CANDIDATE_LIST_FILTER_TOTAL_EXP,
  CANDIDATE_LIST_FLEXIBEES_SELECTED_FILTER,
  CANDIDATE_LIST_LOADER,
  CANDIDATE_LIST_MAX_TOTAL_EXP,
  CANDIDATE_LIST_MIN_TOTAL_EXP,
  CANDIDATE_LIST_ROLES_FILTER,
  CANDIDATE_LIST_SKILLS_FILTER,
  CANDIDATE_LIST_YEARS_OF_BREAK_FILTER,
  CANDIDATE_LIST_YEARS_OF_EXP_FILTER,
  CHANGE_CURRENT_CANDIDATE_PAGE,
  GET_CANDIDATES_CITY_LIST,
  GET_CANDIDATES_LIST,
  GET_CANDIDATES_LIST_FILTERS,
  SEARCH_CANDIDATES,
  SEARCH_CANDIDATES_FILTERS,
  RESET_SEARCH_CANDIDATES_FILTERS,
  SEARCH_CANDIDATES_CITY,
  SET_CANDIDATE_CITY_ITEMS_PER_PAGE,
  SET_CANDIDATE_ITEMS_PER_PAGE,
  VIEW_CANDIDATE_DETAILS,
  VIEW_CANDIDATE_FEEDBACK,
  VIEW_CANDIDATE_JOURNEY,
  VIEW_CANDIDATE_TIMELINE,
  RESET_CANDIDATE_JOURNEY,
  MULTIPLE_CANDIDATE_NOTES,
  PRICING_LISTING,
  PRICING_LIST_LOADER,
  CHANGE_PRICING_CURRENT_CANDIDATE_PAGE,
  SET_ROLE_PRICING_ITEMS_PER_PAGE,
  NEW_PRICING_VALUE,
  SEARCH_ROlE,
  SET_PRICING_HOURS,
  RESET_PRICING_LIST_HOURS,
  VIEW_WARNINGS
} from "../actions/candidateAction";
import { data } from "../container/candidates/candidatesBody/demoData";

const initialState = {
  candidatInfo: {},
  candidateList: [],
  activityCardList: [],
  candidateTimeline: {},
  candidatesListSearchText: "",
  candidatesListCitySearchText: "",
  candidatesListTotalResults: null,
  candidatesListCityTotalResults: null,
  candidatesListCityPages: null,
  candidatesListCurrentPage: 1,
  candidatesListResultsPerPage: 10,
  candidatesCityFilterResultsPerPage: 10,
  candidatesListTotalPages: null,
  candidatesListPageIds: [],
  fetchingData: true,
  fetchingCityData: true,

  // filter default data
  candidatesListFilterSkills: [],
  candidatesListFilterRoles: [],
  candidatesListFilterCities: [],
  candidatesListFilterYearsOfExp: [],
  candidatesListFilterYearsOfBreak: [],
  candidatesListFilterFlexiSelected: [],
  candidatesListFilterActiveProjects: [],
  candidatesListFilterAvailableHours: [],
  // applaid filter

  candidatesSearchAppliedFilters: [],
  candidatesListApplaiedFilterSkills: [],
  candidatesListApplaiedFilterRoles: [],
  candidatesListApplaiedFilterCities: [],
  candidatesListApplaiedFilterYearsOfExp: {},
  candidatesListApplaiedFilterYearsOfBreak: [],
  candidatesListApplaiedFilterFlexiSelected: [],
  candidatesListApplaiedFilterActiveProjects: [],
  candidatesListApplaiedFilterAvailableHours: [],

  candidateListAppliedTotalExpFilterState: false,
  candidateListAppliedMinTotalExpFilter: null,
  candidateListAppliedMaxTotalExpFilter: null,

  candidateJourney: {},
  candidateJourneyFeedback: [],
  multipleCandidatesNotes :[],

  pricingList : [],
  pricingListTotalResults: null,
  pricingListTotalPages: null,
  pricingListPageIds: [],
  pricingListSearchText: "",
  pricingListCurrentPage: 1,
  pricingListResultPerPage: 10,
pricingListHours: '4-5',

warnings:[]
};

const filterActionMap = {
  [CANDIDATE_LIST_CITY_FILTER]: "candidatesListApplaiedFilterCities",
  [CANDIDATE_LIST_ROLES_FILTER]: "candidatesListApplaiedFilterRoles",
  [CANDIDATE_LIST_SKILLS_FILTER]: "candidatesListApplaiedFilterSkills",
  [CANDIDATE_LIST_YEARS_OF_EXP_FILTER]: "candidatesListApplaiedFilterYearsOfExp",
  [CANDIDATE_LIST_YEARS_OF_BREAK_FILTER]: "candidatesListApplaiedFilterYearsOfBreak",
  [CANDIDATE_LIST_AVAILABLE_HOURS_FILTER]: "candidatesListApplaiedFilterAvailableHours",
  [CANDIDATE_LIST_FLEXIBEES_SELECTED_FILTER]: "candidatesListApplaiedFilterFlexiSelected",
  [CANDIDATE_LIST_ACTIVE_PROJECTS_FILTER]: "candidatesListApplaiedFilterActiveProjects",
};

const simplePayloadActionMap = {
  [VIEW_CANDIDATE_FEEDBACK]:               "candidateJourneyFeedback",
  [VIEW_CANDIDATE_JOURNEY]:                "candidateJourney",
  [VIEW_CANDIDATE_TIMELINE]:               "candidateTimeline",
  [CHANGE_CURRENT_CANDIDATE_PAGE]:         "candidatesListCurrentPage",
  [CHANGE_PRICING_CURRENT_CANDIDATE_PAGE]: "pricingListCurrentPage",
  [SET_CANDIDATE_ITEMS_PER_PAGE]:          "candidatesListResultsPerPage",
  [SET_CANDIDATE_CITY_ITEMS_PER_PAGE]:     "candidatesCityFilterResultsPerPage",
  [SET_ROLE_PRICING_ITEMS_PER_PAGE]:       "pricingListResultPerPage",
  [SEARCH_CANDIDATES]:                     "candidatesListSearchText",
  [SEARCH_CANDIDATES_FILTERS]:             "candidatesSearchAppliedFilters",
  [SEARCH_CANDIDATES_CITY]:               "candidatesListCitySearchText",
  [SEARCH_ROlE]:                           "pricingListSearchText",
  [MULTIPLE_CANDIDATE_NOTES]:              "multipleCandidatesNotes",
  [NEW_PRICING_VALUE]:                     "newPricing",
  [SET_PRICING_HOURS]:                     "pricingListHours",
  [VIEW_WARNINGS]:                         "warnings",
};

const loaderActionMap = {
  [PRICING_LIST_LOADER]:        { fetchingData: true },
  [CANDIDATE_LIST_LOADER]:      { fetchingData: true },
  [CANDIDATE_CITY_LIST_LOADER]: { fetchingCityData: true },
};

const expActionMap = {
  [CANDIDATE_LIST_MIN_TOTAL_EXP]:    "candidateListAppliedMinTotalExpFilter",
  [CANDIDATE_LIST_MAX_TOTAL_EXP]:    "candidateListAppliedMaxTotalExpFilter",
  [CANDIDATE_LIST_FILTER_TOTAL_EXP]: "candidateListAppliedTotalExpFilterState",
};

const candidateReducer = (state = initialState, action) => {
  if (filterActionMap[action.type]) {
    return { ...state, [filterActionMap[action.type]]: action.payload };
  }

  if (simplePayloadActionMap[action.type]) {
    return { ...state, [simplePayloadActionMap[action.type]]: action.payload };
  }

  if (loaderActionMap[action.type]) {
    return { ...state, ...loaderActionMap[action.type] };
  }

  if (expActionMap[action.type]) {
    return { ...state, [expActionMap[action.type]]: action.payload };
  }

  switch (action.type) {
    case VIEW_CANDIDATE_DETAILS:
      return {
        ...state,
        candidatInfo: action.payload || data,
      };

    case RESET_CANDIDATE_JOURNEY:
      return {
        ...state,
        candidateJourney: {},
        candidateJourneyFeedback: [],
      };

    case GET_CANDIDATES_LIST:
      return {
        ...state,
        candidateList: action.payload.result.results,
        candidatesListTotalResults: action.payload.result.total_results,
        candidatesListTotalPages: action.payload.result.total_pages,
        candidatesListPageIds: action.payload.result.page_ids,
        fetchingData: false,
      };

    case GET_CANDIDATES_LIST_FILTERS:
      return {
        ...state,
        candidatesListFilterSkills: action?.payload?.skills || [],
        candidatesListFilterRoles: action?.payload?.roles || [],
        candidatesListFilterYearsOfExp: action?.payload?.years_of_experience || {},
        candidatesListFilterYearsOfBreak: action?.payload?.years_of_break || [],
        candidatesListFilterFlexiSelected: action?.payload?.flexibees_selected || [],
        candidatesListFilterActiveProjects: action?.payload?.active_projects || [],
        candidatesListFilterAvailableHours: action?.payload?.total_available_hours || [],
      };

    case GET_CANDIDATES_CITY_LIST:
      return {
        ...state,
        candidatesListFilterCities: action.payload || [],
        candidatesListCityTotalResults: action.total,
        candidatesListCityPages: action.pages,
        fetchingCityData: false,
      };

    case RESET_SEARCH_CANDIDATES_FILTERS:
      return {
        ...state,
        candidatesSearchAppliedFilters: [],
      };

    case PRICING_LISTING:
      return {
        ...state,
        pricingList: action.payload.results,
        pricingListTotalResults: action.payload.total_results,
        pricingListTotalPages: action.payload.total_pages,
        pricingListPageIds: action.payload.page_ids,
        fetchingData: false,
      };

    case RESET_PRICING_LIST_HOURS:
      return {
        ...state,
        pricingListHours: "4-5",
      };

    default:
      return state;
  }
};

export default candidateReducer;
